import React, {FC, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {
  select_gridSession,
  select_gridSession_pageSizeOptions,
  select_status_isPending,
  select_databases,
  select_databases_showDetails,
  select_jobTypeOptionsStatus,
  select_showBulkEditPanel,
} from 'redux/databases/selectors'
import {EmptyStateProps} from 'src/components/EmptyState/index'
import {DataGrid} from '@mdsol/onex-design/DataGrid'
import columnsConfig from './columnsConfig'
import GridControl from './GridControl'
import DatabaseDetails from './DatabaseDetails'
import 'components/common/grid/grid.scss'
import './databases.scss'
import {fetchJobTypeOptions} from '../../../redux/databases/databases.duck'
import {useAppDispatch} from '../../../redux/config'
import {Status} from '../../../commonTypes'
import DatabaseBulkEdit from './DatabaseBulkEdit'
const Databases: FC = () => {
  const dispatch = useAppDispatch()
  const displayRowDetails = useSelector(select_databases_showDetails)
  const showBulkEditPanel = useSelector(select_showBulkEditPanel)
  const databases = useSelector(select_databases)
  const {pagination} = useSelector(select_gridSession)
  const pageSizeOptions = useSelector(select_gridSession_pageSizeOptions)
  const isLoading = useSelector(select_status_isPending)
  const jobTypeOptionStatus = useSelector(select_jobTypeOptionsStatus)

  useEffect(() => {
    dispatch(fetchJobTypeOptions())
  }, [dispatch])

  const emptyStateOptions = databases.length
    ? null
    : {
      title: 'No data',
      subtitle: 'No databases are available.',
      defaultImgVariant: 'noData',
    } as EmptyStateProps

  return (
    <div id='grid-container' className={`${displayRowDetails || showBulkEditPanel? 'with-row-details' : ''}`}>
      <div className='main-content'>
        <DataGrid
          dataTestId='databases-data-grid'
          customGridControl={<GridControl key='key-databases-grid-control' />}
          isLoading={isLoading}
          columns={columnsConfig}
          data={databases}
          manualSorting
          enableSorting
          enablePagination
          pagination={pagination}
          rowsPerPageOptions={[...pageSizeOptions]}
          emptyStateOptions={emptyStateOptions}
        />
      </div>

      {displayRowDetails && jobTypeOptionStatus === Status.OK && (
        <div className='details-panel'>
          <DatabaseDetails />
        </div>
      )}

      {showBulkEditPanel && (
        <div className='details-panel'>
          <DatabaseBulkEdit />
        </div>
      )}
    </div>
  )
}

export default Databases
